import { Seo } from "@/lib/seo";
import { PageHero } from "@/components/page-hero";
import { Reveal } from "@/lib/motion";
import { IntakeForm } from "@/components/intake-form";
import { SITE } from "@/content/site";

export default function Contacto() {
  return (
    <>
      <Seo
        title="Contacto"
        description="Cuéntanos tu situación: nombre, medio de contacto, tema y ubicación del asunto. Te respondemos en horario hábil para agendar la llamada de disponibilidad."
        path="/contacto"
      />
      <PageHero
        eyebrow="Contacto"
        titulo="Cuéntanos tu situación"
        lead="Completa el formulario con lo que tengas a mano. No necesitas tener todo resuelto ni saber qué trámite aplica: eso lo hacemos nosotros."
      />

      <section className="bg-parchment">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 sm:py-24">
          <div className="grid gap-12 lg:grid-cols-12">
            <div className="lg:col-span-5">
              <Reveal>
                <h2 className="font-serif text-2xl text-ink-deep sm:text-3xl">Qué pasa después</h2>
                <ol className="mt-8 space-y-8">
                  {[
                    {
                      n: "01",
                      t: "Leemos tu solicitud",
                      d: "Clasificamos tu asunto y revisamos si es algo en lo que podemos ayudarte.",
                    },
                    {
                      n: "02",
                      t: "Te contactamos",
                      d: "Por el medio que elijas, en horario hábil, para agendar la llamada de disponibilidad.",
                    },
                    {
                      n: "03",
                      t: "Primera conversación",
                      d: "15 a 20 minutos, sin costo: qué pasa, qué documentos faltan y cómo seguir. Sin compromiso de contratación.",
                    },
                  ].map((paso) => (
                    <li key={paso.n} className="flex gap-5" data-testid={`contacto-paso-${paso.n}`}>
                      <span className="font-mono text-sm text-azul">{paso.n}</span>
                      <div>
                        <h3 className="font-medium text-ink-deep">{paso.t}</h3>
                        <p className="mt-1.5 text-sm leading-relaxed text-ink-muted">{paso.d}</p>
                      </div>
                    </li>
                  ))}
                </ol>

                <div className="mt-10 border-l-2 border-azul bg-azul-light/40 p-5">
                  <p className="text-sm leading-relaxed text-ink-text">
                    <strong>La llamada de disponibilidad es gratuita</strong> — {SITE.disponibilidad.toLowerCase().replace("llamada de disponibilidad: ", "")}{" "}
                    Es para confirmar que podemos ayudarte, no para dar asesoría completa. Si tu
                    asunto requiere ir más allá, te lo decimos con costos claros por escrito.
                  </p>
                </div>

                <p className="mt-6 text-sm leading-relaxed text-ink-muted">
                  ¿Hay una notificación o fecha próxima de por medio? Usa la{" "}
                  <a href="/atencion-prioritaria" data-testid="contacto-prioritaria-link" className="font-medium text-azul underline underline-offset-4">
                    ruta de atención prioritaria
                  </a>
                  .
                </p>
              </Reveal>
            </div>

            <div className="lg:col-span-7">
              <Reveal delay={0.1}>
                <IntakeForm variante="completo" />
              </Reveal>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
